import React, { PureComponent } from 'react';
import { DialogContainer } from 'react-md';

export default class ErrorDialog extends PureComponent {
  state = {};

  empty = () => {}

  render () {

    const actions = [{
      id: 'dialog-error-ack',
      children: this.props.labelAck,
      onClick: this.props.onAck
    }];

    return <DialogContainer
      id='dialog-error'
      title={this.props.title}
      actions={actions}
      visible={this.props.visible}
      onHide={this.empty}>
      {this.props.message}
    </DialogContainer>
  }
}


// WEBPACK FOOTER //
// ./src/ErrorDialog.jsx